"use client";

import UspRoadmap from "@/components/newPageComponent/usp/UspRoadmap";
import UspVisitBannerMobile from "@/components/newPageComponent/usp/UspVisitBannerMobile";
import UspShortageDesk from "@/components/pageComponent/lp-usp/uspShortageDesk";
import UspVideoDesk from "@/components/pageComponent/lp-usp/uspVideo";
import Universities from "@/components/pageComponent/lp-usp/universities";
import SolutionsMobile from "@/components/pageComponent/lp-usp/solutions";
import UspAlumniUSMobile from "@/components/newPageComponent/usp/UspAlumniUSMobile";
import UspVisitPoweredByMobile from "@/components/newPageComponent/usp/UspVisitPoweredByMobile";
import UspFaqLanding from "@/components/pageComponent/us-pathway/uspFaqLanding";
import UspVisitRoadmapMobile from "@/components/newPageComponent/usp/UspVisitRoadMapMobile";
import QuickContact from "@/components/common/QuickContact";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import VisitPageHeader from "@/components/common/VisitPageHeader";

const MobilePageLp = () => {
  return (
    <div className="w-full ">
      <VisitPageHeader />
      <UspVisitBannerMobile />
      <UspVisitRoadmapMobile />
      <UspShortageDesk />
      <SolutionsMobile />
      <Universities />
      <UspVideoDesk />
      <UspRoadmap />
      <UspAlumniUSMobile />
      <UspVisitPoweredByMobile />
      <UspFaqLanding />
      <div className="w-full">
        <GlobalFooter />
      </div>
      <QuickContact />
    </div>
  );
};

export default MobilePageLp;
